module.exports = __webpack_public_path__ + "static/media/ios-build.767c1fd0.svg";